import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"
import { IOldUIContext } from "../../global"

import {
    fetchCurrentStatus,
    fetchConcept,
    fetchStatusTransitions,
    initialize,
} from "./slice"

import FlowPanel from "./components/FlowPanel"

interface OldUIInit {
    start: (
        element: HTMLElement | undefined | null,
        conceptId: number,
        itemId: number,
    ) => void
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const start = (
        element: HTMLElement | undefined | null,
        conceptId: number,
        itemId: number,
    ): void => {
        if (!element) {
            // target container doesn't exist, skip initialization
            return
        }

        store.dispatch(initialize({ conceptId, itemId }))
        store.dispatch(fetchStatusTransitions())
        store.dispatch(fetchConcept())
        store.dispatch(fetchCurrentStatus())

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <FlowPanel />
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    return {
        start,
    }
}

export default init
